import { render, staticRenderFns } from "./Exclusions.vue?vue&type=template&id=e511e692&scoped=true"
import script from "./Exclusions.vue?vue&type=script&lang=js"
export * from "./Exclusions.vue?vue&type=script&lang=js"
import style0 from "./Exclusions.vue?vue&type=style&index=0&id=e511e692&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e511e692",
  null
  
)

export default component.exports